export const REPORT_PRESET_TABS = {
  DEFAULT: 'default',
  AI_REMIX: 'ai-remix'
};